import { useCallback } from 'react'
import { useShowToast } from '@/features/shared/state/Toast/hooks'
import { useMutationManagePurchaseHistoryVisibility } from '@/features/shop/services/Search/mutations'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { DynamicConfirmationModal } from '@/features/shared/components/Modal/ConfirmationModal/DynamicConfirmationModal'

export const useDeleteBuyAgainProduct = () => {
  const { openDialog } = useHandleDialog()
  const { showImageToast } = useShowToast()
  const { mutateAsync: managePurchaseHistoryVisibility } =
    useMutationManagePurchaseHistoryVisibility()

  const onDeleteBuyAgainProduct = useCallback(
    (product: { name: string; id: number; image: { url: string } }, onConfirm: () => void) => {
      openDialog(DynamicConfirmationModal, {
        contentLabel: 'Remove from Buy Again',
        modalTitle: 'Remove from Buy Again?',
        modalMessage: `“${product.name}” will be removed from your Buy Again page until it is repurchased.`,
        acceptButtonLabel: 'Remove',
        handleConfirm: async () => {
          await managePurchaseHistoryVisibility(product)
          showImageToast({
            optionalStyling: { marginTop: 52 },
            props: {
              title: 'Removed from Buy Again',
              imageUrl: product.image.url,
            },
          })
          onConfirm()
        },
      })
    },
    [managePurchaseHistoryVisibility, openDialog, showImageToast],
  )

  return { onDeleteBuyAgainProduct }
}
